module.exports = __webpack_public_path__ + "img/team2.ef376a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/team/team2.jpg
// module id = ./static/images/team/team2.jpg
// module chunks = 3